

export const ATTRIBUTE_PREFIX = 'rcz',
    ATTRIBUTE_IF = ATTRIBUTE_PREFIX + ":if",
    ATTRIBUTE_FOR = ATTRIBUTE_PREFIX + ":for",
    ATTRIBUTE_PREFIX_EVENT = ATTRIBUTE_PREFIX + ":on:",
    ATTRIBUTE_REF = ATTRIBUTE_PREFIX + ":ref",
    ATTRIBUTE_TWO_WAY = ATTRIBUTE_PREFIX + ":model",
    ATTRIBUTE_HTML = ATTRIBUTE_PREFIX + ":html",
    ATTRIBUTE_PREFIX_BIND_ATTR = ATTRIBUTE_PREFIX + ":bind:",
    ATTRIBUTE_PREFIX_BIND_ATTR_SHORT = ATTRIBUTE_PREFIX + "::"

export const PREFIX_REF = "ref::",
    PREFIX_REF_LIST = "refs::";

export const ELMENT_REF_PROP_KEY = '::rczRef',
    ELMENT_REF_LIST_PROP_KEY = '::rczRefs'